import { Grid, Typography, Box } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { styles } from "./style/main";

export default function Scale() {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.row}>
        {/* LEFT CARD */}
        <Box sx={styles.card}>
          <Box sx={styles.headingBlock}>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Scale In When Demand is Low
            </Typography>
            <Typography sx={styles.subHead} fontWeight="bold" gutterBottom>
              Efficient Auto-Scaling to Reduce Idle Costs
            </Typography>
          </Box>

          <Box sx={styles.paraList}>
            <Typography className="para" component="div">
              <CircleIcon sx={styles.circleIcon} />
              <span>No more paying for idle servers</span>
            </Typography>
            <Typography className="para" component="div">
              <CircleIcon sx={styles.circleIcon} />
              <span>Zero manual intervention required</span>
            </Typography>
            <Typography className="para" component="div">
              <CircleIcon sx={styles.circleIcon} />
              <span>Always-on monitoring of traffic and load</span>
            </Typography>
          </Box>

          <Box sx={styles.imageWrap}>
            <Box
              component="img"
              src="/images/scale-in.png"
              alt="scale in"
              sx={styles.image}
            />
          </Box>
        </Box>

        {/* RIGHT CARD */}
        <Box sx={styles.card}>
          <Box sx={styles.headingBlock}>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Scale Out During Peak Load
            </Typography>
            <Typography sx={styles.subHead} fontWeight="bold" gutterBottom>
              Pay Less, Handle More
            </Typography>
          </Box>

          <Box sx={styles.paraList}>
            <Typography className="para" component="div">
              <CircleIcon sx={styles.circleIcon} />
              <span>
                Monitors Spot interruptions and seamlessly rebalances workloads
              </span>
            </Typography>
            <Typography className="para" component="div">
              <CircleIcon sx={styles.circleIcon} />
              <span>
                Falls back to on-demand instances for uninterrupted scaling
              </span>
            </Typography>
            <Typography className="para" component="div">
              <CircleIcon sx={styles.circleIcon} />
              <span>
                Dynamically selects the most stable & cost-effective Spot
                markets
              </span>
            </Typography>
          </Box>

          <Box sx={styles.imageWrap}>
            <Box
              component="img"
              src="/images/scale-out.png"
              alt="scale out"
              sx={styles.image}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
